import { render, staticRenderFns } from "./SupporterDetails.vue?vue&type=template&id=0ed30e83&scoped=true&"
import script from "./SupporterDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed30e83",
  null
  
)

export default component.exports